module.exports = "<div layout=\"row\" layout-align=\"end\">\n    <p class=\"f-note md-warn f-note-clickable\"\n       ng-click=\"star.showStarNote($event)\">What does the Star mean? <md-icon class=\"fa fa-question-circle icon-fix\"></md-icon></p>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./feis-list/star-help/tpl.html
// module id = 1127
// module chunks = 0